/**
 * @generated SignedSource<<d704f4f4f0638fe62646e6d25cdc2824>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventTrait = "Autopilot" | "IndividualHold" | "LinkEvent" | "LunchHold" | "OneOnOne" | "OutOfOffice" | "TaskHold" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type SchedulingQueryInput = {
  includeConflictSuggestions?: boolean | null;
  includeRoom: boolean;
  invitees: ReadonlyArray<InviteeContextInput | null>;
  limit: number;
  maxSlot: DayTimeSlotInput;
  minSlot: DayTimeSlotInput;
  minutesDuration: number;
  roomsOverride: ReadonlyArray<string | null>;
  seenSlots: ReadonlyArray<DayTimeSlotInput | null>;
  timeZone: string;
  traits?: ReadonlyArray<EventTrait | null> | null;
};
export type InviteeContextInput = {
  calendarId: string;
  required: boolean;
};
export type DayTimeSlotInput = {
  date: string;
  timeSlot: TimeSlot;
};
export type EventSchedulerTimeInputRendererQuery$variables = {
  orgRelayId: string;
  query: SchedulingQueryInput;
  rescheduler: boolean;
  reschedulerExternalEventId: string;
  reschedulerTimeZone: string;
  reschedulerRangeMin: DayTimeSlotInput;
  reschedulerRangeMax: DayTimeSlotInput;
};
export type EventSchedulerTimeInputRendererQuery$data = {
  readonly node: {
    readonly id: string;
    readonly schedulingResponseErrorable?: {
      readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerTimeInput_schedulingResponseErrorable">;
    };
    readonly reschedulingResponseErrorable?: {
      readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerTimeInput_schedulingResponseErrorable">;
    };
    readonly workingGroups?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly rooms: ReadonlyArray<{
            readonly roomId: string;
            readonly name: string;
          } | null> | null;
        } | null;
      } | null> | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerTimeInput_org">;
  } | null;
};
export type EventSchedulerTimeInputRendererQuery = {
  variables: EventSchedulerTimeInputRendererQuery$variables;
  response: EventSchedulerTimeInputRendererQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgRelayId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rescheduler"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reschedulerExternalEventId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reschedulerRangeMax"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reschedulerRangeMin"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reschedulerTimeZone"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v10 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "EventSchedulerTimeInput_schedulingResponseErrorable"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "externalEventId",
    "variableName": "reschedulerExternalEventId"
  },
  {
    "kind": "Variable",
    "name": "rangeMax",
    "variableName": "reschedulerRangeMax"
  },
  {
    "kind": "Variable",
    "name": "rangeMin",
    "variableName": "reschedulerRangeMin"
  },
  {
    "kind": "Variable",
    "name": "timeZone",
    "variableName": "reschedulerTimeZone"
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roomId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "focusTimeMinutesCost",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateOrDateTime",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timeZone",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "offsetMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "millis",
    "storageKey": null
  }
],
v19 = [
  (v17/*: any*/)
],
v20 = [
  (v15/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isSchedulingResponseErrorable"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uncrawledCalendars",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qualifiers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QueryRecommendation",
        "kind": "LinkedField",
        "name": "queryRecommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutesDuration",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SchedulingSlot",
        "kind": "LinkedField",
        "name": "slots",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SchedulingAttendanceSummary",
            "kind": "LinkedField",
            "name": "summary",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableRooms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tags",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "freeAttendees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inconvenientForAttendees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unavailableAttendees",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conflictingAttendees",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchedulingAttendanceImpact",
            "kind": "LinkedField",
            "name": "attendanceImpacts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inconveniences",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unavailabilities",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasConflict",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conflictingMeetings",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchedulingRoomImpact",
            "kind": "LinkedField",
            "name": "roomImpacts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "available",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tooSmall",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tooLarge",
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeRange",
            "kind": "LinkedField",
            "name": "timeRange",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "endTime",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchedulingMove",
            "kind": "LinkedField",
            "name": "additionalChanges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "organizer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventParent",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalEventId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "startTime",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "endTime",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "from",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "to",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "SchedulingResponse",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
      }
    ],
    "type": "GraphEntityError",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSchedulerTimeInputRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSchedulerTimeInput_org"
              },
              {
                "condition": "rescheduler",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "schedulingResponseErrorable",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "rescheduler",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "reschedulingResponseErrorable",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "WorkingGroupConnection",
                "kind": "LinkedField",
                "name": "workingGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Room",
                            "kind": "LinkedField",
                            "name": "rooms",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workingGroups(first:1000000)"
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventSchedulerTimeInputRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "WorkingGroupConnection",
                "kind": "LinkedField",
                "name": "workingGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Room",
                            "kind": "LinkedField",
                            "name": "rooms",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workingGroups(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
              },
              {
                "condition": "rescheduler",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "schedulingResponseErrorable",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "rescheduler",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "reschedulingResponseErrorable",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bc54c8abdb70f539a1088677b0c4d7ab",
    "id": null,
    "metadata": {},
    "name": "EventSchedulerTimeInputRendererQuery",
    "operationKind": "query",
    "text": "query EventSchedulerTimeInputRendererQuery(\n  $orgRelayId: ID!\n  $query: SchedulingQueryInput!\n  $rescheduler: Boolean!\n  $reschedulerExternalEventId: String!\n  $reschedulerTimeZone: String!\n  $reschedulerRangeMin: DayTimeSlotInput!\n  $reschedulerRangeMax: DayTimeSlotInput!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      ...EventSchedulerTimeInput_org\n      schedulingResponseErrorable(query: $query) @skip(if: $rescheduler) {\n        __typename\n        ...EventSchedulerTimeInput_schedulingResponseErrorable\n      }\n      reschedulingResponseErrorable(externalEventId: $reschedulerExternalEventId, timeZone: $reschedulerTimeZone, rangeMin: $reschedulerRangeMin, rangeMax: $reschedulerRangeMax) @include(if: $rescheduler) {\n        __typename\n        ...EventSchedulerTimeInput_schedulingResponseErrorable\n      }\n      workingGroups(first: 1000000) {\n        edges {\n          node {\n            id\n            rooms {\n              roomId\n              name\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSchedulerSuggestedTimes_org on Org {\n  id\n  experiments\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        rooms {\n          roomId\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment EventSchedulerSuggestedTimes_schedulingResponse on SchedulingResponse {\n  uncrawledCalendars\n  qualifiers\n  queryRecommendation {\n    availableDate\n    minutesDuration\n  }\n  slots {\n    summary {\n      availableRooms\n      tags\n      freeAttendees\n      inconvenientForAttendees\n      unavailableAttendees\n      focusTimeMinutesCost\n      conflictingAttendees\n    }\n    attendanceImpacts {\n      calendarId\n      inconveniences\n      unavailabilities\n      hasConflict\n      focusTimeMinutesCost\n      conflictingMeetings\n    }\n    roomImpacts {\n      available\n      tooSmall\n      tooLarge\n      roomId\n    }\n    timeRange {\n      id\n      startTime {\n        type\n        dateOrDateTime\n        timeZone\n        offsetMinutes\n        millis\n      }\n      endTime {\n        type\n        dateOrDateTime\n        timeZone\n        offsetMinutes\n        millis\n      }\n    }\n    additionalChanges {\n      organizer\n      event {\n        id\n        externalEventId\n        events {\n          id\n          title\n          startTime {\n            dateOrDateTime\n          }\n          endTime {\n            dateOrDateTime\n          }\n        }\n      }\n      from\n      to\n    }\n  }\n}\n\nfragment EventSchedulerTimeInput_org on Org {\n  ...EventSchedulerSuggestedTimes_org\n  id\n  primaryOrgCalendar\n  experiments\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        rooms {\n          roomId\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment EventSchedulerTimeInput_schedulingResponseErrorable on SchedulingResponseErrorable {\n  __isSchedulingResponseErrorable: __typename\n  __typename\n  ... on SchedulingResponse {\n    ...EventSchedulerSuggestedTimes_schedulingResponse\n    uncrawledCalendars\n    qualifiers\n    queryRecommendation {\n      minutesDuration\n      availableDate\n    }\n    slots {\n      summary {\n        availableRooms\n        tags\n        freeAttendees\n        inconvenientForAttendees\n        unavailableAttendees\n        focusTimeMinutesCost\n        conflictingAttendees\n      }\n      attendanceImpacts {\n        hasConflict\n        calendarId\n        focusTimeMinutesCost\n        inconveniences\n        unavailabilities\n        conflictingMeetings\n      }\n      roomImpacts {\n        roomId\n        available\n      }\n      timeRange {\n        id\n        startTime {\n          type\n          dateOrDateTime\n          timeZone\n          offsetMinutes\n          millis\n        }\n        endTime {\n          type\n          dateOrDateTime\n          timeZone\n          offsetMinutes\n          millis\n        }\n      }\n      additionalChanges {\n        organizer\n        event {\n          id\n          externalEventId\n          events {\n            id\n            title\n            startTime {\n              dateOrDateTime\n            }\n            endTime {\n              dateOrDateTime\n            }\n          }\n        }\n        from\n        to\n      }\n    }\n  }\n  ... on GraphEntityError {\n    message\n    statusCode\n    body\n  }\n}\n"
  }
};
})();

(node as any).hash = "2afa11c5382b404b034c1666412e073d";

export default node;
